import { render, staticRenderFns } from "./LoginHeader.vue?vue&type=template&id=0315827a&scoped=true"
import script from "./LoginHeader.vue?vue&type=script&lang=js"
export * from "./LoginHeader.vue?vue&type=script&lang=js"
import style0 from "./LoginHeader.vue?vue&type=style&index=0&id=0315827a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0315827a",
  null
  
)

export default component.exports